import './Audio.scss';
import React, { useState, useEffect } from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import {connect} from "react-redux";
import { useDispatch } from 'react-redux';
import AudioPlayer from "../../../shared/component/AudioPlayer/AudioPlayer"
import snippets from "../../../helpers/snippets";
import {_loading} from "../../../actions/Loading";
import config from "../../../config";
import BaseApi from "../../../core/api/BaseApi";

const baseApi = new BaseApi()

// const mimeType = "audio/webm";

function Audio(props) {
    const user = useState(Storage.getUserInfo());
    const language = props.language
    const numberKind = language === "fa" ? snippets.toFarsiNumber : snippets.toEnglishNumber
    const dispatch = useDispatch();

    const [permission, setPermission] = useState(false);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audioBlob, setAudioBlob] = useState(null);

    const [timerStart , setTimerStart] = useState(0)
    const [timerPause , setTimerPause] = useState(0)
    const [timerDuration , setTimerDuration] = useState(0)

    const [voices, setVoices] = useState([])
    const [voicesPlayPause, setVoicesPlayPause] = useState("paused")


    useEffect(() => {
        // 👇️ run a function when the component unmounts 👇️
        return () => {
            stream && stream.getTracks().forEach((track) => track.stop());
        };
    }, []);

    useEffect(() => {
        setTimerDuration( pervTimerDuration => pervTimerDuration + timerPause-timerStart)
    }, [timerPause]);

    useEffect(() => {
        if (audioBlob) {
            const url = URL.createObjectURL(audioBlob);
            setAudioUrl(url)
        }
    }, [audioBlob]);

    useEffect(() => {
        setVoices(props.voices)
    }, [props.voices]);

    const onClose = () => {
        props.onClose();
    }


    const getMicrophonePermission = async () => {
        if (window.location.protocol !== 'https:') {
            alert("it is better to run audio recording over HTTPS! use the https version of SinaPAX");
            return
        }
        if ("MediaRecorder" in window) {
            try {
                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                // !MediaRecorder.isTypeSupported(mimeType) && console.log("browser dose not support this mime type!")
                setPermission(true);
                // setStream(mediaStream);
                startRecording()
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const startRecordingClick=()=>{
        if (permission) {
            startRecording()
        }else{
            getMicrophonePermission()
        }
    }

    const startRecording =  () => {
        setRecordingStatus("recording");
        setTimerStart(Date.now())
        // const media = new MediaRecorder(stream, { type: mimeType });
        // mediaRecorder.current = media;
        // mediaRecorder.current.start();
        // let localAudioChunks = [];
        // mediaRecorder.current.ondataavailable = (event) => {
        //     if (typeof event.data === "undefined") return;
        //     if (event.data.size === 0) return;
        //     localAudioChunks.push(event.data);
        // };
        // setAudioChunks(localAudioChunks);

        // mediaRecorder.current = new MediaRecorder(stream);
        // mediaRecorder.current.start();
        // mediaRecorder.current.ondataavailable = (event) => {
        //     audioChunks.current.push(event.data);
        // };

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
                const recorder = new MediaRecorder(stream, {
                    mimeType: "audio/webm; codecs=opus"
                });
                setMediaRecorder(recorder);
                setStream(stream)
                recorder.addEventListener("dataavailable", event => {
                    audioChunks.push(event.data);
                });
                recorder.addEventListener("stop", () => {
                    const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
                    setAudioBlob(audioBlob);
                    stream.getTracks().forEach((track) => track.stop());
                });
                recorder.start();
            })
    };

    const stopRecording = () => {
        // mediaRecorder.current.stop();
        // mediaRecorder.current.onstop = () => {
        //     const audioBlob = new Blob(audioChunks.current, { type: "audio/webm" });
        //     const audioUrl = URL.createObjectURL(audioBlob);
        //     setAudioUrl(audioUrl);
        //     audioChunks.current = [];
        // };
        if (mediaRecorder) {
            mediaRecorder.stop();
            setRecordingStatus("stopped");

        }
    };
    const pauseRecording = () => {
        setRecordingStatus("paused");
        setTimerPause(Date.now())
        // mediaRecorder.current.pause();
        mediaRecorder.pause();

    };

    const resumeRecording = () => {
        setTimerStart(Date.now())
        setRecordingStatus("recording");
        // mediaRecorder.current.resume();
        mediaRecorder.resume();

    };
    const deleteRecording = () => {
        setRecordingStatus("inactive")
        setMediaRecorder(null);
        setAudioChunks([]);
        // setStream(null)
        setAudioUrl([]);
        setTimerStart(0)
        setTimerPause(0)
        setTimerDuration(0)
    };

    const getTimeFormat = (time) => {
        return `${numberKind(snippets.minTwoDigits(Math.floor((time / 1000 / 60))))}:${numberKind(snippets.minTwoDigits(((time / 1000) % 60).toFixed(2)))}`


    };
    const Timer = () => {
        const numberKind = language === "fa" ? snippets.toFarsiNumber : snippets.toEnglishNumber
        // const [hours, setHours] = useState(0);
        const [minutes, setMinutes] = useState(0);
        // const [seconds, setSeconds] = useState(0);
        const [miliSeconds, setMiliSeconds] = useState(0);
        const getTime = () => {
            const time =  Date.now() - timerStart + timerDuration ;
            // setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
            setMinutes(Math.floor((time / 1000 / 60) ));
            // setSeconds(Math.floor((time / 1000) % 60));
            setMiliSeconds(((time / 1000) % 60).toFixed(2));
        };

        useEffect(() => {
            const interval = setInterval(() => getTime(), 7);
            return () => clearInterval(interval);
        }, []);
        return (<>{numberKind(snippets.minTwoDigits(minutes))}:{numberKind(snippets.minTwoDigits(miliSeconds))}</>);
    };

    const sendToServer=()=>{
        dispatch(_loading(true));
        const formData = new FormData();
        formData.append('voice', audioBlob);
        formData.append('study_id', props.studyId);
        formData.append('report_id', props.reportId);
        baseApi.fullFetch("audio", "create", {data:formData, version:2}).then(()=>{
            props.update()
        })
    }

    const handleVoicesPlayPause = (voice) =>{
        // setVoicesPlayPause
    }

    return (
        <>
            <div className="audio">
                <div className={'audio__header'}>
                    <div className={'audio__header__close'}
                        onClick={() => onClose()}
                    >
                        <i className="fal fa-times-circle" />
                    </div>
                    <div className={'audio__header__title'}>
                        {<T token={'voice'} />}
                    </div>

                    <div className={'audio__header__newVoice'}>
                        {<T token={'new_voice'} />}
                    </div>
                </div>

                <hr />

                <div className={'audio__body'}>
                    <div className={`section__record ${recordingStatus === "recording" ? "Rec": ""}`}>
                        <div className='section__record__top'>
                            <div className='section__record__top__title'>
                                <T token={"new_voice"} />
                            </div>
                            {recordingStatus === "stopped" ?
                                <div className='section__record__i'>
                                    <div className='section__record__circle Rec'
                                         onClick={() => sendToServer()}
                                    >
                                        <i className={'fal fa-cloud-upload'}/>
                                    </div>
                                    {audioUrl &&
                                        <div className='section__record__circle'>
                                            <a download="recording" href={audioUrl}>
                                                <i className={'fal fa-save'}
                                                />
                                            </a>
                                        </div>}
                                    {/*<div className='section__record__circle'>*/}
                                    {/*    <i className={'fal fa-light fa-edit'} />*/}
                                    {/*</div>*/}
                                    <div className='section__record__circle'
                                         onClick={()=> deleteRecording()}
                                    >
                                        <i className={'fal fa-light fa-trash-can'} style={{ color: "red" }}/>
                                    </div>
                                </div>
                                : null}
                        </div>
                        <div className='section__record__bottom'>
                            <div className={`section__record__i ${recordingStatus}`}>

                                    {recordingStatus === "inactive" &&
                                        <div className='section__record__circle'
                                             onClick={() => startRecordingClick()}
                                        >
                                            <i className={'fal fa-microphone'} />
                                        </div>
                                    }
                                    {recordingStatus === "recording" &&
                                        <>
                                            <div className='section__record__circle'
                                                 onClick={() => stopRecording()}
                                            >
                                                <i className={'fal fa-stop'} />
                                            </div>

                                            <div className='section__record__circle'
                                                 onClick={() => pauseRecording()}
                                            >
                                                <i className={'fal fa-pause'}/>
                                            </div>
                                        </>
                                    }
                                    {recordingStatus === "paused" &&
                                        <>
                                            <div className='section__record__circle Rec'
                                                 onClick={() => stopRecording()}
                                            >
                                                <i className={'fal fa-stop'}/>
                                            </div>

                                            <div className='section__record__circle Rec'
                                                 onClick={() => resumeRecording()}
                                            >
                                                <i className={'fal fa-play'}/>
                                            </div>
                                        </>
                                    }

                                {recordingStatus === "stopped" &&
                                    <>


                                    </>
                                }
                            </div>
                            <div className='timer'>
                                {(recordingStatus === "recording" ) &&
                                    <Timer />
                                }{(recordingStatus === "paused" ) &&
                                    <>{getTimeFormat(timerDuration)}</>
                                }

                            </div>
                            {(recordingStatus === "stopped" && audioUrl) &&
                                <AudioPlayer src={audioUrl} />
                                // <audio src={audioUrl} controls></audio>
                            }
                        </div>
                    </div>


                    { !props.hasAudio ?
                        <div style={{ color: "red" }}>there is no audio for your Choice!</div>
                        :
                        <div className={'section__content'}>
                            {voices.map((item, index) =>
                                <div className='__lists'
                                    key={index}
                                    // title=
                                // onClick={(event) => this.templateClick(item.id, event)}
                                >
                                    <div className={"audio_top"}>
                                        <div className='__contents'>
                                            {item.uri}
                                        </div>
                                    </div>
                                    <div className={"audio_down"}>
                                        {/*<div className='section__record__circle'*/}
                                        {/*     onClick={() => handleVoicesPlayPause(item)}*/}
                                        {/*>*/}
                                        {/*    {voicesPlayPause === "paused" ? <i className={'fal fa-play'}/>*/}
                                        {/*    : voicesPlayPause === "playing" ? <i className={'fal fa-pause'}/>*/}
                                        {/*    :  <i className={'fal fa-stop'}/>  }*/}
                                        {/*</div>*/}
                                        <audio src={`${config.baseUrl}${item.uri}`}
                                               controls
                                               // onPlay={() => setIsPlaying(true)}
                                               // onPause={() => setIsPlaying(false)}

                                        />
                                        {/*<div className='__title'>*/}
                                        {/*    {item.duration}*/}
                                        {/*</div>*/}
                                    </div>


                                </div>

                            )}
                        </div>
                    }
                </div>
            </div>

        </>

    )
};


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(Audio);